<template>
    <section class="content">
        <div class="wrap">
            <div class="infomation">
            <dl class="area" v-show="getAboInfoCheck">
                <dt class="content-title">당첨자</dt>
                <dd class="content-text">{{ aboInfo.aboName }}(<span>{{ aboInfo.aboNo }}</span>)님</dd>
            </dl>
            <dl class="area">
                <dt class="content-title">사용 가능 기간</dt>
                <dd class="content-text">{{getFormattedDays(couponInfo.start_date)}} ~ {{getFormattedDays(couponInfo.end_date)}}</dd>
                <dt>(재고 소진시 까지)</dt>
            </dl>
            <dl class="area">
                <dt class="content-title">교환처</dt>
                <template v-if="couponInfo.store_code==0">
                <dd class="content-text link">
                    <p><span>{{ couponInfo.store_name }}</span></p>
                    <a @click="linkToABCSearcher"><span>ABC</span> 찾기</a>
                </dd>
                </template>
                <template v-else>
                <dd class="content-text">
                    <span>{{ couponInfo.store_name }}</span>
                    <p class="content-subtext" v-html="getProductNameForEnter(couponInfo.store_address)"></p>
                </dd>
                </template>
            </dl>
            <dl class="area">
                <dt class="content-title">사용안내</dt>
                <dd class="content-description">가까운 ABC/A STATION 방문 후 안내데스크 직원에게 제품 교환권을 보여주시면 제품을 교환해드립니다.</dd>
                <dd class="content-description">교환권은 사용 가능 기간 내에 개별적으로 교환 받을 수 있습니다.</dd>
                <dd class="content-description">사용 가능 기간이 지날 경우 제품 교환이 불가합니다.</dd>
                <dd class="content-description">제품 교환권이 포함된 메시지 삭제 시 재발급이 불가합니다.</dd>
            </dl>
            <dl class="area">
                <dt class="content-title">수량</dt>
                <dd>
                <div>
                    <p class="mark">교환가능</p>
                    <p class="count">{{ couponInfo.total_coupon }}<span>개</span></p>
                </div>
                <div v-if="couponInfo.used_coupon>0">
                    <p class="mark mark--complete">교환완료</p>
                    <p class="count">{{ couponInfo.used_coupon }}<span>개</span></p>
                    <button type="button" class="more-button" :class="{'active':openDetails}" @click="openDetailsClick" >교환내역보기</button>
                </div>
                <div class="detail" :class="{'active':openDetails}">
                    <div v-for="(item, index) in couponDetail" :key="index">
                    <p class="date"><span>{{getFormattedDays(item.update_date)}}</span></p>
                    <p class="count"><span>{{ item.used_count }}</span>개</p>
                    <p class="position">{{ item.store_name }}</p>
                    </div>
                </div>
                </dd>
            </dl>
            </div>
            <div class="variation">
            <div class="quantity">
                <p>교환수량선택</p>
                <div>
                <button class="minus" @click="minusSelector" :class="[countData<2?'no-active':'']"><span class="read-only">빼기</span></button>
                <p class="quantity-number">{{ countData }}</p>
                <button class="plus" @click="plusSelector" ><span class="read-only">더하기</span></button>
                </div>
            </div>
            <div class="confirm" v-if="couponInfo.total_coupon>0">
                <p>매장 선택 후, 직원 확인용 비밀번호를 입력해주세요.</p>
                <div class="select">
                <select v-model="selectStore" :disabled="couponInfo.store_code!=0">
                    <option :key="index" :value="item.code" v-for="(item, index) in storeItems">{{ item.value }}</option>
                </select>
                <input type="password" placeholder="비밀번호를 입력해주세요." v-model="inputPassword"/>
                </div>
            </div>
            </div>
        </div>
        <div class="etc-buttons">
            <template v-if="couponInfo.NotReady">
                <button type="button" class="check check--end-date" >{{ getFormattedDays(couponInfo.start_date) }}부터 사용 가능</button>
            </template>
            <template v-else-if="couponInfo.IsExpired">
                <button type="button" class="check check--end-date" >사용 기한 만료</button>
            </template>
            <template v-else-if="couponInfo.total_coupon>0">
                <button type="button" class="check" @click="confirmCoupon">직원 확인</button>
            </template>
            <template v-else>
                <button type="button" class="check check--complete" >교환 완료</button>
            </template>
        </div>
    </section>
</template>
    
<script>
import axios from 'axios'
export default {
    name: 'coupondetail',
    props:{
        propCouponInfo: {},
        propCouponDetail: [],
        aboInfo: {},
        couponNo: ''
    },
    data () {
        return {
            couponInfo: {},
            couponDetail: [],
            ready: false,
            openDetails:false,
            countData: 1,
            storeItems:[],
            selectStore: 1,
            inputPassword:'',
            openDetails:false,
        }
    },
    computed:{
        getAboInfoCheck: function(){
            if(this.aboInfo){
                if(this.aboInfo.aboNo){
                    return true
                }
            }
            return false
        },
    },
    methods: {
        init: async function () { // 초기화
            this.couponInfo=this.propCouponInfo
            this.couponDetail=this.propCouponDetail
            this.getStoreInfo()
        },
        openDetailsClick: function(){
        if(this.openDetails){
            this.openDetails=false
            return
        }
        if(this.couponInfo.used_coupon>0){
            this.openDetails=true
        }
        },
        confirmCoupon: function(){
            if(this.inputPassword===''){
                alert('패스워드를 입력해 주세요.')
                return
            }
            let tempPW=this.inputPassword
            this.inputPassword=''
            this.isLoading = true
            axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/couponsys_usecoupon',
                { 
                "coupon_number":this.couponNo,
                "store_code":this.selectStore,
                "password":tempPW,
                "quentity":this.countData,
                },{headers: {'Content-Type': 'application/json;charset=UTF-8'}} // Header
            ).then(response => {
            if (response.status === 200) {        
                if (response.data){
                    console.log("Coupon use :::"+JSON.stringify(response.data))
                    this.getCouponInformation()
                    if(response.data.results.length>0 && response.data.results[0].res>0){
                        alert(this.countData + '개 사용 완료')
                    }else{
                        alert('사용 수량 혹은 패스워드 확인 필요')
                    }
                }
            } else {
                alert('사용 실패')
            }
                this.isLoading = false
                }).catch(error => {
                console.log('error : ', error)
                this.isLoading = false
            })
        },
        plusSelector: function(){
            if(this.countData<this.couponInfo.total_coupon)
                this.countData++
        },
        minusSelector: function(){
            if(this.countData>1)
                this.countData--
        },
        getProductNameForEnter: function(pName){
            if(pName){
                return pName.replace(/(?:\r\n|\r|\n)/g, '<br />');
            }
            return pName
        },
        getCouponInformation: async function(){
            await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/couponsys_getcouponinfo', {
                "coupon_number":this.couponNo
            }).then(response => {
            if (response.status === 200) {
                this.couponInfo=response.data.info[0]
                this.couponDetail=response.data.detail
            } else {
                console.log('response.status : ', response.status)
                alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            }
            }).catch(error => {
                console.log('error : ', error)
                alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            })
        },
        getStoreInfo: function(){
            this.isLoading = true
            axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/couponsys_getcoupons'
            , { "mode":'S', },{headers: {'Content-Type': 'application/json;charset=UTF-8'}} // Header
            ).then(response => {
                if (response.status === 200) {        
                    if (response.data){
                        this.inputTheArrays(response.data.store, this.storeItems)
                        this.selectStore=(this.couponInfo.store_code===0?1:this.couponInfo.store_code)
                    }
                } else {
                    alert('초기화 실패')
                }
                this.isLoading = false
            }).catch(error => {
                console.log('error : ', error)
                this.isLoading = false
            })
        },
        inputTheArrays: function(data, container){
            if(typeof data !== 'undefined' && data.length > 0){
                data.forEach(item => {
                if(item.code!==0)           
                    container.push({ code:item.code, value:item.value })
                })
            }
        },
        getFormattedDays: function(ymd){
            const dt = Date.parse(ymd)
            if (!isNaN(dt)) {
                const rawDate = new Date(dt);
                const year = rawDate.getFullYear();
                const month = rawDate.getMonth() + 1;
                const date = rawDate.getDate();
                const c_day = ['(일)','(월)','(화)','(수)','(목)','(금)','(토)']
                const DayOfWeek = c_day[rawDate.getDay()]
                return (`${year}.${month >= 10 ? month : '0' + month}.${date >= 10 ? date : '0' + date} ${DayOfWeek}`);
            }
            return ''
        },
        linkToABCSearcher: function(){
            window.open('https://www.amway.co.kr/store-finder')
        },
    },
    mounted() {
        window.setTimeout(() => {
            this.ready = true
            this.init()
        }, 500)
    },
}
</script>


// WEBPACK FOOTER //
// src/views/couponsys/component/coupondetail.vue